window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Cache-Control'] = 'no-cache';


import Vue from 'vue'
import App from './components/App.vue'
import Welcome from './components/Welcome.vue'
import Activate from './components/Activate.vue'
import Voucher from './components/Voucher.vue'
import Redeemed from './components/Redeemed.vue'
import ErrorComp from './components/Error.vue'
import ToggleVoucher from './components/ToggleVoucher.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex';
var WebFont = require('webfontloader');

import Mixins from './mixins/global.js';

Vue.mixin(Mixins);

Vue.config.productionTip = false;

Vue.use(Vuex);




window.axios.interceptors.response.use( (response) => {
	return response;
    
},  (error) => {
    store.commit("SET_SCREEN",'error');
    store.commit("SET_ERROR_RESPONSE",error.response.data);
	// Do something with response error
    return Promise.reject(error);
});



import "./scss/global.scss";
Vue.component('activate', Activate);
Vue.component('voucher', Voucher);
Vue.component('redeemed', Redeemed);
Vue.component('welcome', Welcome);
Vue.component('error', ErrorComp);
Vue.component('toggle-voucher', ToggleVoucher);


new Vue({
  router,
  store,
  render: h => h(App),
  computed:{

        config(){
          return this.$store.getters.getCamapignConfig;
	    },
               
    },
    watch :{

        config: function(newVal, oldVal){
        	if(newVal.is_google_font)
            this.fontLoad(newVal.font_family);
        },

    },
  methods:{

	  	// load google fonts
        fontLoad(fonts)
        {
            WebFont.load({
                google: {
                    families: [fonts]
                }
            });
        }

    }
}).$mount('#app')
